import { Phone } from "lucide-react";
import { SITE } from "@/data/siteData";

/**
 * Premium sticky call bar visible on BOTH mobile and desktop.
 * Stays fixed at the bottom regardless of scroll direction.
 */
export default function StickyCallBar() {
  return (
    <div
      data-testid="sticky-call-bar"
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#00367e] text-white shadow-[0_-8px_30px_rgba(0,54,126,0.25)] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-3.5 flex items-center justify-between gap-3 md:gap-5">
        <div className="hidden md:flex items-center gap-3 min-w-0">
          <span className="relative flex items-center justify-center w-11 h-11 rounded-full bg-white/10">
            <span className="absolute inset-0 rounded-full bg-white/15 dh-pulse" aria-hidden="true" />
            <Phone size={20} className="relative text-white" strokeWidth={2.4} />
          </span>
          <div className="leading-tight min-w-0">
            <div className="text-[11px] uppercase tracking-[0.18em] text-white/70 font-bold">
              Disponible {SITE.hoursLabel}
            </div>
            <div className="font-extrabold text-base md:text-lg truncate">
              Besoin d'un dégraissage&nbsp;? Appelez-nous.
            </div>
          </div>
        </div>

        <a
          href={`tel:${SITE.phoneTel}`}
          data-testid="sticky-call-cta"
          aria-label={`Appeler maintenant le ${SITE.phoneDisplay}`}
          className="dh-cta-shine flex-1 md:flex-initial inline-flex items-center justify-center gap-2.5 px-5 md:px-7 py-3.5 md:py-4 rounded-full bg-white text-[#00367e] font-extrabold text-base md:text-lg shadow-lg hover:bg-slate-100 transition-colors"
        >
          <Phone size={20} strokeWidth={2.6} />
          <span className="whitespace-nowrap">
            <span className="md:hidden">APPELER · {SITE.phoneDisplay}</span>
            <span className="hidden md:inline">APPELER MAINTENANT · {SITE.phoneDisplay}</span>
          </span>
        </a>
      </div>
    </div>
  );
}
